// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Layout_Alert__otp64","inside":"Layout_inside__1A__y","button":"Layout_button__3NMqU","Content":"Layout_Content__2ZjSY","Footer":"Layout_Footer__1NUYI"};